import { DialogBody, DialogStep, Intent, MultistepDialog, Spinner } from "@blueprintjs/core";
import { getThemeClass, useTheme } from "@/components/global/theme";
import React, { useEffect, useMemo } from "react";
import { useWrapup } from "./wrapupcontext";
import getWrapupDialogPanels from "./panels";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    userId?: number;
}

export default function WrapupDialog(
    {
        isOpen,
        onClose,
        userId,
    }: Props,
): React.ReactNode {
    const { theme } = useTheme();
    const { getWrapup, wrapupData } = useWrapup();

    useEffect(
        () => {
            if (!wrapupData) {
                getWrapup(userId);
            }
        },
        [getWrapup, wrapupData, userId],
    );

    const steps = useMemo(
        () => {
            if (!wrapupData) {
                return <DialogStep
                    id='loading'
                    title='Loading'
                    panel={
                        <DialogBody>
                            <Spinner />
                        </DialogBody>
                    }
                />
            }

            return getWrapupDialogPanels(wrapupData);
        },
        [wrapupData],
    );

    return <MultistepDialog
        className={getThemeClass(theme)}
        finalButtonProps={{
            intent: Intent.PRIMARY,
            onClick: onClose,
            text: "Close",
        }}
        isOpen={isOpen}
        onClose={onClose}
        title='SPQR Wrapup 2025'
    >
        {steps}
    </MultistepDialog>
}
